var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:_vm.$style.container},[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{class:_vm.$style.overlay,on:{"click":function($event){$event.stopPropagation();return _vm.handleClose.apply(null, arguments)}}})]),_c('transition',{attrs:{"name":"bottom-animate","appear":""}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }